<div [id]="'loader-spinner-'+loader.from"
    class="common-spinner__window-loader">
      @if(text !== ''){
        <div class="common-spinner__block-spinner-description">
          <p-progressSpinner styleClass="common-spinner__progress-container-white-XL"
            ariaLabel="loading"></p-progressSpinner>
          <span class="common-spinner__description-text-white-XL"
              [afTranslate]="text">_abriendo en pestaña nueva</span>
        </div>
      }@else {
        <p-progressSpinner styleClass="common-spinner__progress-container-white-XL"
          ariaLabel="loading">
        </p-progressSpinner>
      }
</div>
